import { OBJECT_FREEZE_HELPER } from "../../../_Helpers/ObjectFreeze.helper";

const _SCHEMA = {
    HAS_CART: true,
    HAS_BLOG: true,
    HAS_FAVS: true,
    HAS_SEARCH: true,
    HAS_ROUTING: true,
    HAS_PROFILE: true,
    HAS_REGISTER: true,
    HAS_SOCKET_IO: true,
    HAS_LANGUAGES: true,
    HAS_CHAT_EMAIL: true,
    HAS_PAGINATION: true,
    HAS_UPLOAD_FILES: true,
    HAS_NOTIFICATIONS: true,
    HAS_CHAT_MESSAGES: true,
    HAS_CHAT_WHATSAPP: true,
    HAS_USER_SETTINGS: true,
    HAS_PAYMENT_METHOD: true,
    HAS_AUTH_USER_SIMPLE: true,
    HAS_PASSWORD_RECOVERY: true,
    HAS_ONLY_LANDING_PAGE: true,
    HAS_PAGINATION_ADVANCED: true,
    HAS_AUTH_USER_PORTAL_ROL: true,
    HAS_METHOD_VERIFY_2_STEPS: true,
    HAS_SEARCH_FILTER_ADVANCED: true,
    HAS_AUTH_USER_PORTAL_CLIENT: true,
};


export const APP__PLUGINS = OBJECT_FREEZE_HELPER(_SCHEMA);